<template>
  <v-container fluid class="mx-0 px-0">
    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :item-class="rowClass"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
      group-by="dalis_index"
    >
      <template #top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <template #[`group.header`]="{ headers, items }">
        <td :colspan="headers.length">
          <el-checkbox
            class="mb-2 mt-0"
            :label="`Dalis ${items[0].dalis}`"
            :key="items[0].tnd_id"
            v-model="turtasDalysList"
            :checkValue="items[0].tnd_id"
            :readonly="
              (readonly && !isAntstolisPakeitimas) ||
                isAdresas ||
                turtineTeise ||
                !items[0].dalis_redaguojama
            "
          />
        </td>
      </template>
      <template #[`item.atstovas`]="{ item }">
        {{ item.atstovas_pavadinimas }}
        <div class="text-gray">
          {{ item.atstovas_veikiantis_pagal }}
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action
          :item="item.actions"
          @viewItem="editItem(item)"
          @addAtstovas="addAtstovas(item)"
          @viewAtstovas="viewAtstovas(item)"
          @deleteAtstovas="deleteAtstovas(item)"
        />
      </template>

      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-asmuo
      :key="modalAsmuoKey"
      v-model="showAsmuo"
      :asmuo="modalAsmuo"
      :asmuo-role="modalAsmuoRole"
      :parent-atstovas-id="modalParentAtstovasId"
      :salys="salys"
      :atnaujinti="atnaujintiAsmuo"
      :atstovavimo-pagrindas="atstovavimo_pagrindas"
      :readonly="modalAsmuoReadonly"
      :tik-adresas="isAdresas"
      @savedData="savedAsmuo"
      @savedAtstovas="savedAtstovas"
    />
    <modal-delete
      title="Šalinti asmenį?"
      :text="
        `Ar norite pašalinti asmenį <strong>${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import HipotekaMap from '../hipotekaMap'
import ModalAsmuo from '../../modals/ModalAsmuo'
import ModalDelete from '../../modals/ModalDelete'
import rowClass from '../../../mixins/rowClass'
import busena from '../../../mixins/busena'

export default {
  name: 'TurtasNtrDavejas',
  components: {
    ModalAsmuo,
    ModalDelete,
  },
  props: {
    asmuoRole: String,
    turtasDalys: { type: Array, default: () => [] },
    turtineTeise: { type: Boolean, default: false },
    antstolisPakeitimas: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  mixins: [busena, rowClass],
  data() {
    return {
      pageloading: true,
      loading: true,
      savitarnaSkolininkaiLoading: false,
      search: null,
      showAsmuo: false,
      modalAsmuoReadonly: false,
      modalAsmuoKey: 'asmuo',
      modalAsmuoRefresh: 0,
      modalAsmuo: {},
      modalSavininkas: false,
      modalAsmuoRole: null,
      modalParentAtstovasId: null,
      showAsmuoSelect: false,
      asmuoSelectTitle: null,
      asmuoSelectList: [],
      asmuoSelectPazymeti: [],
      salys: [],
      atstovavimo_pagrindas: [],
      modalInformavimasItem: {},
      modalInformavimasKey: 'informavimas',
      modalInformavimasRefresh: 0,
      showInformavimas: false,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      dalys: [],
      asmenys: [],
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters([
      'objektasID',
      'hipotekaTipas',
      'turtasID',
      'hipotekaBusena',
      'appSavitarna',
      'turtasRusis',
    ]),
    headers() {
      return [
        {
          text: 'Dalis',
          align: 'center',
          sortable: false,
          value: 'dalis_index',
        },
        {
          text: 'Asmens kodas',
          align: 'start',
          sortable: false,
          value: 'asm_asmens_kodas',
        },
        {
          text: 'Vardas Pavardė / Pavadinimas',
          align: 'start',
          sortable: false,
          value: 'asm_pavadinimas',
        },
        {
          text: 'Adresas',
          align: 'start',
          sortable: false,
          value: 'adr_text',
          hide: this.informuojamas,
        },
        {
          text: 'Atstovas',
          align: 'start',
          value: 'atstovas',
          hide: !this.showAtstovasCell,
        },
        {
          text: 'Asmens dokumentas',
          align: 'start',
          value: 'sasm_fiz_dok_info',
          hide: !this.showAsmensDokumentas,
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      let newList = []
      this.dalys.forEach((dalis, dalisIndex) => {
        dalis.asmenys.forEach((asmuo, index) => {
          const isAtstovas = asmuo.atstovas_sasm_id > 0
          newList.push({
            tnd_id: dalis.tnd_id,
            dalis_index: dalisIndex,
            dalis: dalis.dalis,
            dalis_redaguojama: dalis.dalis_redaguojama,
            ...asmuo,
            sasm_fiz_dok_info: isAtstovas
              ? asmuo.atstovas_fiz_dok_info
              : asmuo.sasm_fiz_dok_info,
            atstovas_veikiantis_pagal:
              isAtstovas && asmuo.atstovas_veikiantis_pagal
                ? `Veikiantis pagal: ${asmuo.atstovas_veikiantis_pagal}`
                : '',
            actions: {
              readonly: true,
              canView: true,
              canAddAtstovas: asmuo.tipas === 'JUR' && !isAtstovas,
              canViewAtstovas: isAtstovas,
              canDeleteAtstovas: isAtstovas && !this.readonly,
            },
          })
        })
      })
      return newList
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    isAntstolisPakeitimas() {
      return this.antstolisPakeitimas && (this.isRengiamas || this.isGrazintas)
    },
    turto_davejas() {
      return this.asmuoRole === HipotekaMap['asmenysRoles'].turtas_davejas
    },
    turtasDalysList: {
      set(value) {
        this.$emit('updateTurtasDalys', value)
      },
      get() {
        return this.turtasDalys
      },
    },
    isSavitarna() {
      return this.appSavitarna
    },
    isAdresas() {
      return (
        this.hipotekaTipas.includes('adresas') &&
        (this.isRengiamas || this.isGrazintas)
      )
    },
    atnaujintiAsmuo() {
      return this.isRengiamas || this.isPerduotas || this.isGrazintas
    },
    showAtstovasCell() {
      return (
        this.itemsList.filter(asmuo => asmuo.atstovas_pavadinimas).length > 0
      )
    },
    showAsmensDokumentas() {
      return this.itemsList.filter(asmuo => asmuo.sasm_fiz_dok_info).length > 0
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(
          `objektas/${this.objektasID}/turtas/${this.turtasID}/${this.turtasRusis}/dalis`
        )
        .then(res => {
          this.dalys = res.data.dalys
          this.salys = res.data.salys
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },

    editItem(item) {
      this.openAsmuo(item.sasm_id, this.readonly)
    },
    openAsmuo(sasm_id, readonly = false) {
      this.modalAsmuo = {
        sasm_id: sasm_id,
      }
      this.modalAsmuoReadonly = readonly
      this.modalAsmuoRole = this.asmuoRole
      this.modalParentAtstovasId = null
      this.modalAsmuoKey =
        'asmuo' + (sasm_id ?? 'new' + this.modalAsmuoRefresh++)
      this.showAsmuo = true
    },
    savedAsmuo(modalAsmuo, atstovas = false) {
      this.loading = true

      let data = modalAsmuo
      data.obj_id = this.objektasID
      data.tur_id = this.turtas ? this.turtasID : null
      data.vyk_id = this.vykdomasisId
      data.sasm_role_objekte = this.asmuoRole
      if (atstovas) {
        data.sasm_role_objekte = 'atstovas'
      }

      this.$axios
        .post(`asmuo`, data)
        .then(res => {
          this.modalAsmuoKey = 'asmuo'
          window._VMA.$emit('DATA_OK', res.data.message)
          this.showAsmuo = false
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    addAtstovas(item) {
      this.openAtstovas(null, item.sasm_id)
    },
    viewAtstovas(item) {
      this.openAtstovas(item.atstovas_sasm_id, item.sasm_id, this.readonly)
    },
    openAtstovas(sasm_id, parent_atstovas_id, readonly = false) {
      this.modalAsmuo = {
        sasm_id: sasm_id,
      }
      this.modalAsmuoReadonly = readonly
      this.modalAsmuoRole = 'atstovas'
      this.modalParentAtstovasId = parent_atstovas_id
      this.modalAsmuoKey =
        'asmuo' + (sasm_id ?? 'new' + this.modalAsmuoRefresh++)
      this.showAsmuo = true
    },
    savedAtstovas(modalAsmuo) {
      this.loading = true

      modalAsmuo.sasm_atstovaujamas_id = modalAsmuo.parent_atstovas_id
      this.savedAsmuo(modalAsmuo, true)
    },
    deleteAtstovas(item) {
      this.modalDeleteVardas = item.atstovas_pavadinimas
      this.modalDeleteItem = Object.assign({}, item)
      this.modalDeleteRole = 'atstovas'
      this.showDelete = true
    },
    confirmDelete(item) {
      if (this.modalDeleteRole === 'atstovas') {
        this.confirmDeleteAtstovas(item)
      }
    },
    confirmDeleteAtstovas(item) {
      this.loading = true

      this.$axios
        .delete(`asmuo/${item.sasm_id}/atstovas`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getActiveClass(item) {
      if (!this.turtasDalysList.includes(item.tnd_id)) {
        return 'ntr-inactive-dalis'
      }
      return ''
    },
  },
}
</script>
